"use client";

import React from "react";

import ImageTitleContent from "@/components/data/ImageTitleContent";
import Modal, { useModalState } from "@/components/misc/Modal";
import Icon from "@/components/misc/Icon";
import Button from "@/components/input/Button";
import { useResponsive } from "@/styles";
import { SITE_PATHS } from "@/config/routing";
import {
  ContractCompleteDetails,
  getContractManagePageUrl,
  useShareOfferViaEmail,
} from "@/services/ContractsService";
import { analytics } from "@/config/services";

import {
  StyledBottomContainer,
  StyledButton,
  StyledContainer,
  StyledShareButton,
  StyledTopContainer,
  StyledButtonContainer,
} from "./SuccessScreen.styles";
import { useContractForm } from "../../../ContractForm.context";

const SuccessScreen: React.FC = () => {
  const { isScreenSmallerThanTablet } = useResponsive();
  const { createdContractDetails } = useContractForm();
  const { triggerShare, formModalJsx } = useShareOfferViaEmail({
    contractDetails: createdContractDetails || ({} as ContractCompleteDetails),
    successRedirectRoute: SITE_PATHS.HOME_PAGE,
    share_source: "after_form_create",
  });

  const contractId = createdContractDetails?.id || "";
  const contractTitle = createdContractDetails?.title || "";

  const state = useModalState({ isOpen: true });

  return (
    <>
      {formModalJsx}

      <Modal
        fullscreen
        className="p-0"
        state={state}
        containerProps={
          isScreenSmallerThanTablet ? { style: { zIndex: -1 } } : {}
        }
      >
        <StyledContainer>
          <StyledButtonContainer>
            <StyledButton
              variant="ghost"
              link={getContractManagePageUrl(contractId)}
            >
              <Icon
                src="/assets/images/icons/chevron_left.svg"
                size="xxs"
                colorVariant="black"
              />
            </StyledButton>

            <StyledButton variant="ghost" link={SITE_PATHS.HOME_PAGE}>
              <Icon
                src="/assets/images/icons/cross.svg"
                size="xxs"
                colorVariant="black"
              />
            </StyledButton>
          </StyledButtonContainer>

          <StyledTopContainer>
            <ImageTitleContent
              title="Offer Created!"
              content={
                <>
                  Your offer has been successfully created and is ready to share
                  with your client.
                </>
              }
              image="/assets/images/pages/contracts/contract_created.svg"
            />
          </StyledTopContainer>

          <StyledBottomContainer>
            <Button onClick={triggerShare}>
              Send to email <Icon isSrcRelative src="mail.svg" size="xs" />
            </Button>

            <StyledShareButton
              className="mt-1"
              contractId={contractId}
              contractDetails={createdContractDetails || undefined}
              variant="ghost"
              onClick={({ shareType }) => {
                analytics.triggerShareOfferEvent("share_offer", {
                  source: "after_form_create",
                  share_type: shareType,
                  offer_id: contractId,
                  offer_name: contractTitle,
                });
              }}
            >
              Or share via
              <Icon
                isSrcRelative
                src="share_2.svg"
                size="xxs"
                colorVariant="black"
              />
            </StyledShareButton>
          </StyledBottomContainer>
        </StyledContainer>
      </Modal>
    </>
  );
};

export default SuccessScreen;
